export default "__VITE_ASSET__08766a3d__"